export @{}
  u8_to_base64,
  base64_to_u8,

  u8_to_base64url,
  base64url_to_u8,
from './base64_str.jsy'


export async function blob_to_dataurl(blob) ::
  blob = await blob
  let rdr = new FileReader()
  await new Promise @\ onload, onerror ::
    rdr.onload = onload
    rdr.onerror = onerror
    rdr.readAsDataURL(blob)
  return rdr.result

